// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import UserIcon from 'components/atoms/UserIcon'

const Wrapper = styled.div`
  &::after {
    display: block;
    clear: both;
    content: '';
  }

  ${mediaMin.phone`
    margin-right: 50px;
  `};
`
const Container = styled.div`
  display: table;
  table-layout: fixed;
  width: 100%;
`
const StatusWrapper = styled.div`
  display: inline-block;
  padding-left: ${spacing.small_2}px;
  vertical-align: bottom;
`
const Status = styled.span`
  display: block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: left;
  line-height: 1.5;
`
const MessageWrapper = styled.div`
  display: table-cell;
  padding: ${spacing.small_2}px 0 ${spacing.small_2}px ${spacing.small_2}px;
`
const UserIconContainer = styled.div`
  display: table-cell;
  width: 40px;
`
const Message = styled.div`
  display: inline-block;
  max-width: calc(100% - 40px);
  padding: ${spacing.small_2}px ${spacing.small_3}px;
  vertical-align: bottom;
  line-height: 1.7;
  border-radius: 16px;
  border-bottom-left-radius: ${borderRadius}px;
  background-color: ${Colors.grayF};
  white-space: pre-wrap;
  font-size: ${fontSize.small_3}px;
  ${mediaMin.phone`
    padding: ${spacing.medium}px;
  `};
`
const UserIconWrapper = styled.div`
  margin-bottom: -${spacing.small_3}px;
`

type PropTypes = {
  opponentImage: string,
  time?: string,
  messageText: string,
}

export default (props: PropTypes) => (
  <Wrapper>
    <Container>
      <UserIconContainer>
        <UserIconWrapper>
          <UserIcon src={props.opponentImage} medium />
        </UserIconWrapper>
      </UserIconContainer>
      <MessageWrapper>
        <Message dangerouslySetInnerHTML={{ __html: props.messageText }} />
        <StatusWrapper>
          <Status>{props.time}</Status>
        </StatusWrapper>
      </MessageWrapper>
    </Container>
  </Wrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/MessageOpponent/index.jsx